<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";

const props = defineProps(["modelValue", "partialSelect", "error"]);
const emit = defineEmits(["update:modelValue"]);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>

<template>
  <div v-if="partialSelect" class="input_checkbox_partial">
    <SvgIcon class="!checked:bg-transparent absolute cursor-pointer" name="checkbox-minus"></SvgIcon>
    <input v-model="value" type="checkbox" class="cursor-pointer opacity-0" v-bind="$attrs" />
  </div>
  <div
    v-else
    class="input_checkbox"
    :class="{
      input_checked: $attrs.checked,
      input_disabled: $attrs.disabled,
      input_error: error,
      input_readonly: $attrs.readonly,
    }"
  >
    <SvgIcon
      class="pointer-events-none absolute justify-center items-center z-1"
      :class="[
        $attrs.checked ? 'flex' : 'hidden',
        $attrs.disabled || $attrs.readonly ? 'cursor-default' : 'cursor-pointer',
      ]"
      name="checkbox"
    >
    </SvgIcon>
    <input
      v-model="value"
      type="checkbox"
      class="z-0 opacity-0"
      :class="[$attrs.disabled || $attrs.readonly ? 'cursor-default' : 'cursor-pointer']"
      v-bind="$attrs"
    />
  </div>
</template>

<style lang="scss" scoped>
.input_checkbox {
  @apply flex justify-center items-center relative rounded-[5px] min-w-[16px] w-[16px] h-[16px] bg-white;
  border: 1px solid var(--text-tertiary-color);
  color: var(--text-tertiary-color);
  z-index: 100;
  cursor: pointer;
  transition:
    background 0.3s,
    border-color 0.3s;

  &:hover:not(.input_disabled):not(.input_readonly):not(.input_checked) {
    border-color: var(--black-dark);
  }

  &.input_checked {
    background: var(--primary-blue-color);
    border-color: var(--primary-blue-color);

    &:hover {
      background: var(--blue-dark);
      border-color: var(--blue-dark);
    }
  }

  &.input_disabled {
    border-color: var(--grey-medium-light);
    background: transparent;
    cursor: default;

    &.input_checked {
      border-color: transparent;
      background: var(--grey-medium-light);
    }
  }

  &.input_readonly {
    cursor: default;

    &.input_checked {
      background: var(--primary-blue-color);
      border-color: var(--primary-blue-color);
    }
  }

  &.input_error {
    border-color: var(--red-main) !important;
  }
}

.input_checkbox_partial {
  @apply flex justify-center items-center relative rounded-[5px] w-[16px] h-[16px] bg-white cursor-pointer;
  border: 1px solid var(--black-dark);
  color: var(--black-dark);
  transition: border-color 0.3s;

  &:hover:not(.input_disabled):not(.input_readonly) {
    border-color: var(--black-dark);
  }

  &:has(> input:disabled) {
    opacity: 0.5;
    border: 1px solid var(--grey-medium-light);
    color: var(--grey-medium-light);
  }
}
</style>
